<template>
  <page-container>
    <div class="ant-pro-table">
      <div class="ant-pro-table-search">
        <search-render
          ref="config_render"
          :form="searchConfig"
          :model="searchConfig.model"
          :options="searchConfigOptions"
          :validateInfos="validateInfos"
          :resetFields="resetFields"
          @search="search"
        />
      </div>
      <a-card :body-style="{ padding: 0 }" ref="elRef">
        <div class="ant-pro-table-list-toolbar">
          <div class="ant-pro-table-list-toolbar-container">
            <div class="ant-pro-table-list-toolbar-left">
              <div class="ant-pro-table-list-toolbar-title">{{ titleList.title }}</div>
            </div>
            <div class="ant-pro-table-list-toolbar-right">
              <a-space align="center">
                <a-button
                  v-for="btn in custom_btn_list"
                  size="small"
                  :key="btn.name"
                  @click="btn.cb"
                  :type="btn.clazz"
                >
                  {{ btn.name }}
                </a-button>

                <div class="ant-pro-table-list-toolbar-setting-item">
                  <a-tooltip title="展示全部列">
                    <a-switch
                      checked-children="全部"
                      un-checked-children="默认"
                      v-model:checked="checkAll"
                      @change="column_change()"
                    />
                  </a-tooltip>
                </div>
                <div class="ant-pro-table-list-toolbar-setting-item">
                  <a-tooltip title="【显示、隐藏】操作列">
                    <a-switch
                      checked-children="操作"
                      un-checked-children="操作"
                      v-model:checked="checkAction"
                      @change="columnAction()"
                    />
                  </a-tooltip>
                </div>
              </a-space>
              <div class="ant-pro-table-list-toolbar-divider">
                <a-divider type="vertical" />
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="刷新">
                  <reload-outlined @click="handleTableChange" />
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="密度">
                  <a-dropdown :trigger="['click']" placement="bottomRight">
                    <column-height-outlined />
                    <template #overlay>
                      <a-menu
                        style="width: 80px"
                        :selected-keys="[state.tableSize]"
                        @click="
                          ({ key }) => {
                            state.tableSize = key;
                          }
                        "
                      >
                        <a-menu-item key="default">
                          <a href="javascript:">默认</a>
                        </a-menu-item>
                        <a-menu-item key="middle">
                          <a href="javascript:">中等</a>
                        </a-menu-item>
                        <a-menu-item key="small">
                          <a href="javascript:">紧凑</a>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-popover
                  placement="bottomRight"
                  arrowPointAtCenter
                  trigger="click"
                  overlayClassName="ant-pro-table-column-setting-overlay"
                >
                  <template #title>
                    <div class="ant-pro-table-column-setting-title">
                      <a-checkbox
                        v-model:checked="columnState.checkAll"
                        :indeterminate="columnState.indeterminate"
                        @change="handleColumnAllClick"
                      >
                        列展示
                      </a-checkbox>
                      <a @click="reset">重置</a>
                    </div>
                  </template>
                  <template #content>
                    <span class="ant-pro-table-column-setting-list">
                      <drag-container
                        lockAxis="y"
                        dragClass="ant-pro-table-drag-ghost"
                        dropClass="ant-pro-table-drop-ghost"
                        @drop="({ removedIndex, addedIndex }) => move(removedIndex, addedIndex)"
                      >
                        <draggable :key="column.key" v-for="column in dynamicColumnItems">
                          <div class="ant-pro-table-column-setting-list-item">
                            <drag-icon />
                            <a-checkbox
                              :checked="column.checked"
                              @change="handleColumnChange($event, column)"
                            >
                              {{ column.label }}
                            </a-checkbox>
                          </div>
                        </draggable>
                      </drag-container>
                    </span>
                  </template>
                  <a-tooltip title="列设置">
                    <setting-outlined />
                  </a-tooltip>
                </a-popover>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip :title="screenState ? '退出全屏' : '全屏'">
                  <fullscreen-outlined v-if="!screenState" @click="setFull" />
                  <fullscreen-exit-outlined v-else @click="exitFull" />
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>
        <a-affix :offset-top="top">
          <a-table
            bordered="true"
            :scroll="{ y: tableHeight.y, x: columnState.tableWidth }"
            :row-class-name="stripe"
            :size="state.tableSize"
            :loading="state.loading"
            :columns="dynamicColumns"
            :data-source="state.dataSource"
            :indentSize="0"
            :rowKey="'id'"
            :pagination="{
              current: state.current,
              pageSize: state.pageSize,
              total: state.total,
            }"
            @change="handleTableChange"
          >
            <template
              v-for="item in slotList"
              v-slot:[item.slotName]="{ index, text }"
              :key="item.slotName"
            >
              <span v-if="item.slotName === 'index'">
                {{ index + 1 + state.pageSize * (state.current - 1) }}
              </span>
              <span v-if="item.type === 'custom'">
                {{ item['field_' + text] }}
              </span>
              <span v-if="item.type === 'datetime'">
                {{ getDateTime(text) }}
              </span>
              <span v-if="item.type === 'date'">
                {{ getDate(text) }}
              </span>
              <span v-if="item.type === 'time'">
                {{ getTime(text) }}
              </span>
              <a-tag color="green" v-if="text && item.type === 'boolean'">{{ item.name1 }}</a-tag>
              <a-tag color="red" v-if="!text && item.type === 'boolean'">{{ item.name2 }}</a-tag>
              <template v-if="item.type === 'list'">
                <a-tag color="#87d068" v-for="obj in text" :key="obj.id" style="margin-bottom: 1px">
                  {{ obj.name }}
                </a-tag>
              </template>
            </template>
            <template #action="{ record }">
              <a-button
                v-for="btn in btn_list"
                size="small"
                v-show="btn?.is_show ? btn.is_show(record) : true"
                :key="btn.name"
                :type="btn.clazz"
                @click="btn.cb(record)"
              >
                {{ btn.name }}
              </a-button>
              <a-button
                v-for="btn in custom_row_btn_list"
                size="small"
                v-show="btn?.is_show ? btn.is_show(record) : true"
                :key="btn.name"
                :type="btn.clazz"
                @click="btn.cb(record)"
              >
                {{ btn.name }}
              </a-button>
            </template>
          </a-table>
        </a-affix>
      </a-card>
    </div>
    <orderusedrecordmodel
      v-bind="modifyModal"
      v-if="modifyModal.visible"
      @cancel="modifyModalCancel"
      @ok="modifyModalOk"
    ></orderusedrecordmodel>
  </page-container>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted } from 'vue';
import {
  ReloadOutlined,
  ColumnHeightOutlined,
  SettingOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from '@ant-design/icons-vue';
import { Container as DragContainer, Draggable } from '@/components/draggable';
import { Pagination, TableFilters, TableColumn, TableColumnSortOrder } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import DragIcon from '@/components/table/drag-icon.vue';
import Orderusedrecordmodel from '@/views/mjstore/orderusedrecord/orderusedrecordmodel/orderusedrecordmodel.vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import { useForm } from 'ant-design-vue/es/form';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import getPageConfig from '@/components/page-model/index';
import { useRoute } from 'vue-router';
import { Record } from '@/components/page-model/typing';
import config from '@/views/mjstore/orderusedrecord/mjstore-orderusedrecord';
import { btnTd } from '@/api/typing';

export default defineComponent({
  name: 'Orderusedrecord',
  props: {},
  setup() {
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const checkAll = ref<boolean>(false);
    const checkAction = ref<boolean>(false);
    const tableHeight = reactive({ y: window.innerHeight - 130 });
    onMounted(() => {
      window.onresize = function () {
        tableHeight.y = window.innerHeight - 130;
      };
    });

    const route = useRoute();
    const path_arr = route.path.split('/');
    const field = { modalType: path_arr[path_arr.length - 1] };

    // 时间区间格式转化 数组-->字符串
    const getRangePicker = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string].join(',');
        }
      }
      return obj;
    };

    const {
      searchConfig,
      searchConfigOptions,
      queryData,
      baseColumns,
      slotList,
      titleList,
      api_fields,
      event_obj,
      btn_list,
    } = config();

    if (searchConfig.fields) {
      for (let i = 0; i < searchConfig.fields.length; i++) {
        // 预先填充 placeholder
        let filed_dict = searchConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }
        // 预先填充 校验message
        let search_rule_dict = searchConfig.rules[filed_dict.name];
        if (search_rule_dict) {
          if (!search_rule_dict.message) {
            search_rule_dict.message = filed_dict.placeholder;
          }
        }
      }
    }

    event_obj?.on('refresh', () => {
      reload();
    });
    event_obj?.on('reset_and_reload', () => {
      reload();
    });
    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
    } = useTableDynamicColumns(baseColumns as TableColumn[], {
      checkAll: false,
      needRowIndex: false,
    });
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
    const modelRef = reactive({
      ...searchConfig.model,
    });
    const { resetFields, validateInfos } = useForm(searchConfig.model, searchConfig.rules);

    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(queryData, {
      current: 1,
      pageSize: 20,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...modelRef,
        ...getRangePicker(api_fields.rangepicker, modelRef),
      },
    });
    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      let filter_map: any = {};
      for (let key in filters) {
        filter_map[key] = filters[key].map((x: any) => x.toString()).join(',');
      }
      setPageInfo({
        current,
        pageSize,
        ...modelRef,
        ...filter_map,
      });
      reload();
    };

    const search = () => {
      setPageInfo({
        current: 1,
        ...searchConfig.model,
        ...getRangePicker(api_fields.rangepicker, searchConfig.model),
      });
      reload();
    };

    let currentRecord = reactive({ name: '', mid: 0 });

    // 字段对应错误————>转化正确
    const getObjList = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string];
        }
      }
      return obj;
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };

    // 列’默认‘ ’全部‘ 展示的切换
    let old_list: any[] = []; // 定义old_list记录默认数据
    const column_change = () => {
      if (checkAll.value) {
        dynamicColumnItems.value.forEach(org => {
          old_list.push(org);
          let b = {
            ...org,
            checked: true,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        });
      } else {
        old_list.forEach(org => {
          let a: any = {};
          a.target = org;
          handleColumnChange(a, org);
        });
      }
    };
    const columnAction = () => {
      dynamicColumnItems.value.forEach(org => {
        if (org.key == 'action') {
          let b = {
            ...org,
            checked: checkAction.value,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        }
      });
    };
    const modifyModal = reactive({
      visible: false,
      obj: {
        org_id: current_org?.id,
        id: -1,
      },
    });
    const custom_btn_list: btnTd[] = [];
    const custom_row_btn_list = [
      {
        name: '退货',
        clazz: 'primary',
        is_show: (record: any) => {
          return (
            record.is_delete == false &&
            (record.card__project_type__p_type == 21 || record.project__project_type__p_type == 20)
          );
        },
        cb: (record: any) => {
          modifyModal.obj = {
            org_id: current_org?.id,
            id: record.id,
          };
          modifyModal.visible = true;
          currentRecord.mid = 0;
        },
      },
    ];
    const modifyModalCancel = () => {
      modifyModal.visible = false;
    };
    const modifyModalOk = (data: any) => {
      if (currentRecord.mid == 0) {
        reload();
      } else {
        Object.assign(currentRecord, data);
      }
      modifyModal.visible = false;
    };

    return {
      getDateTime,
      getTime,
      getDate,
      getRangePicker,
      column_change,
      columnAction,
      checkAll,
      checkAction,
      slotList,
      titleList,
      tableHeight,
      state,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,
      currentRecord,
      modelRef,
      resetFields,
      validateInfos,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,
      handleTableChange,
      search,
      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,
      current_org,
      message,
      reload,
      getPageConfig,
      searchConfig,
      searchConfigOptions,
      getObjList,
      field,
      api_fields,
      btn_list,
      custom_btn_list,
      custom_row_btn_list,
      modifyModal,
      modifyModalOk,
      modifyModalCancel,
    };
  },
  components: {
    DragIcon,
    ReloadOutlined,
    ColumnHeightOutlined,
    SettingOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    Draggable,
    DragContainer,
    SearchRender,
    Orderusedrecordmodel,
  },
});
</script>
